/**
 * How long ago, in words, for surfaces where minutes matter.
 *
 * Distinct from `ago` in `pulse-format.ts` on purpose: that one answers "how
 * stale is this page" and is right to say "today" for anything inside a day.
 * A device that signed in, or a revision somebody just committed, is a
 * different question — "today" for three commits in a row says nothing about
 * their order.
 */
export function timeAgo(iso: string): string {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000)
  if (minutes < 1) return 'just now'
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`
  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`
  const days = Math.round(hours / 24)
  if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`
  return new Date(iso).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}
